import Vue from 'vue';

const defaultOptions = {
  theme: 'toasted-primary' as const,
  position: 'top-right' as const,
  duration: 5000,
  class: 'spireworks_toast',
  containerClass: 'spireworks_toast_container',
};

export function errorToast(message: string) {
  Vue.toasted.show(message, {
    type: 'error',
    ...defaultOptions,
  });
}

export function successToast(message: string) {
  Vue.toasted.show(message, {
    type: 'info',
    ...defaultOptions,
  });
}

export function clearToasts() {
  Vue.toasted.clear();
}
